export const entityRouter = {
    path: 'entity',
    name: 'Entity',
    component: () => import(/* webpackChunkName: "l" */ '../../views/Entity.vue'),
    meta: {},
    children: [
        {
            path: ':type',
            name: 'List',
            component: () => import(/* webpackChunkName: "l" */ '../../views/EntityList.vue'),
            meta: {
                keepAlive: true
            },
        },
        {
            path: ':type/add',
            name: 'AddEntity',
            component: () => import(/* webpackChunkName: "a" */ '../../views/EntityDetail.vue'),
            meta: {
                keepAlive: false,
                nv: true
            },

        },
        {
            path: ':type/detail/:id',
            name: 'EntityDetail',
            component: () => import(/* webpackChunkName: "d" */ '../../views/EntityDetail.vue'),
            meta: {
                keepAlive: false,
                nv: true
            },
        }
    ]
};

export const homeRouter = {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "password" */ '../../views/Home.vue'),
    children: []
};

const activityList = {
    id: 'activityList',
    router: {
        path: '/activity',
        name: 'ActivityList',
        component: () => import(/* webpackChunkName: "al" */ '../../views/activity/List'),
        meta: {
            title: '活动管理'
        }
    }
};

const createActivity = {
    id: 'createActivity',
    router: {
        path: '/create-activity/:id',
        name: 'CreateActivity',
        component: () => import(/* webpackChunkName: "ca" */ '../../views/activity/create/CreateActivity'),
        meta: {
            title: '创建活动'
        }
    }
};

const activity = {
    id: 'activity',
    router: {
        path: 'act/:id',
        name: 'Activity',
        redirect: {name: 'ActivityInfo'},
        component: () => import(/* webpackChunkName: "act" */ '../../views/activity/Activity.vue'),
        children: []
    }
}

const activityInfo = {
    id: 'activityInfo',
    router: {
        path: 'info',
        name: 'ActivityInfo',
        component: () => import(/* webpackChunkName: "ai" */ '../../views/activity/Info.vue'),
        meta: {
            title: '活动概览'
        }
    },
    parent: 'activity'
}

const activityDetail = {
    id: 'activityDetail',
    router: {
        path: 'detail',
        name: 'ActivityDetail',
        component: () => import(/* webpackChunkName: "ad" */ '../../views/activity/Detail.vue'),
        meta: {
            title: '基本信息'
        }
    },
    parent: 'activity'
}


const activityGroup = {
    id: 'activityGroup',
    router: {
        path: 'group',
        name: 'ActivityGroup',
        component: () => import(/* webpackChunkName: "ag" */ '../../views/activity/Group.vue'),
        meta: {
            title: '活动日程'
        }
    },
    parent: 'activity'
}


const activityDecorate = {
    id: 'activityDecorate',
    router: {
        path: '/decorate/act/:id',
        name: 'ActivityDecorate',
        component: () => import(/* webpackChunkName: "ade" */ '../../views/Decorate'),
        meta: {
            title: '活动首页装修'
        }
    },
}

const activityStaff = {
    id: 'activityStaff',
    router: {
        path: 'staff',
        name: 'ActivityStaff',
        component: () => import(/* webpackChunkName: "as" */ '../../views/activity/Staff.vue'),
        meta: {
            title: '工作人员管理'
        }
    },
    parent: 'activity'
}

const activityHomePreview = {
    id: 'activityHomePreview',
    router: {
        path: 'home-preview',
        name: 'ActivityHomePreview',
        component: () => import(/* webpackChunkName: "home-prev" */ '../../views/activity/furnish/Preview.vue'),
        meta: {
            title: '首页预览'
        }
    },
    parent: 'activity'
}

const activitySchedule = {
    id: 'activitySchedule',
    router: {
        path: 'schedule',
        name: 'ActivitySchedule',
        component: () => import(/* webpackChunkName: "sch" */ '../../views/activity/furnish/Schedule.vue'),
        meta: {
            title: '官方日程'
        }
    },
    parent: 'activity'
}

const activityArticle = {
    id: 'activityArticle',
    router: {
        path: 'article',
        name: 'ActivityArticle',
        component: () => import(/* webpackChunkName: "aa" */ '../../views/activity/furnish/Article.vue'),
        meta: {
            title: '文章列表'
        }
    },
    parent: 'activity'
}

const activityVideo = {
    id: 'activityVideo',
    router: {
        path: 'video',
        name: 'ActivityVideo',
        component: () => import(/* webpackChunkName: "av" */ '../../views/activity/furnish/Video.vue'),
        meta: {
            title: '视频列表'
        }
    },
    parent: 'activity'
}


const activityGuest = {
    id: 'activityGuest',
    router: {
        path: 'guest',
        name: 'ActivityGuest',
        component: () => import(/* webpackChunkName: "guest" */ '../../views/activity/guest/Invite.vue'),
        meta: {
            title: '嘉宾邀请'
        }
    },
    parent: 'activity'
};

const activityGuestVerify = {
    id: 'activityGuestVerify',
    router: {
        path: 'guest-verify',
        name: 'ActivityGuestVerify',
        component: () => import(/* webpackChunkName: "guest-verify" */ '../../views/activity/guest/Verify.vue'),
        meta: {
            title: '嘉宾审核'
        }
    },
    parent: 'activity'
};

const activityGuestInfo = {
    id: 'activityGuestInfo',
    router: {
        path: 'guest/:guest',
        name: 'ActivityGuestInfo',
        component: () => import(/* webpackChunkName: "guest-info" */ '../../views/activity/guest/Info.vue'),
        meta: {
            title: '嘉宾信息'
        }
    },
    parent: 'activity'
};

const activityLocation = {
    id: 'activityLocation',
    router: {
        path: 'location',
        name: 'ActivityLocation',
        component: () => import(/* webpackChunkName: "location" */ '../../views/activity/Location.vue'),
        meta: {
            title: '导览管理'
        }
    },
    parent: 'activity'
};

const activityEnroll = {
    id: 'activityEnroll',
    router: {
        path: 'enroll',
        name: 'ActivityEnroll',
        component: () => import(/* webpackChunkName: "enroll" */ '../../views/activity/Enroll.vue'),
        meta: {
            title: '报名管理'
        }
    },
    parent: 'activity'
};

const activityMealAssign = {
    id: 'activityMealAssign',
    router: {
        path: 'meal-assign',
        name: 'ActivityMealAssign',
        component: () => import(/* webpackChunkName: "meal-assign" */ '../../views/activity/meal/Assign.vue'),
        meta: {
            title: '用餐分配'
        }
    },
    parent: 'activity'
};


const activityMealInfo = {
    id: 'activityMealInfo',
    router: {
        path: 'meal-info',
        name: 'ActivityMealInfo',
        component: () => import(/* webpackChunkName: "meal-info" */ '../../views/activity/meal/AssignInfo.vue'),
        meta: {
            title: '用餐信息'
        }
    },
    parent: 'activity'
};

const activityMeal = {
    id: 'activityMeal',
    router: {
        path: 'meal',
        name: 'ActivityMeal',
        component: () => import(/* webpackChunkName: "meal" */ '../../views/activity/meal/Type.vue'),
        meta: {
            title: '用餐规格'
        }
    },
    parent: 'activity'
};

const activityFoodOrder = {
    id: 'activityFood',
    router: {
        path: 'food-order',
        name: 'ActivityFoodOrder',
        component: () => import(/* webpackChunkName: "food-order" */ '../../views/activity/food/FoodOrder.vue'),
        meta: {
            title: '订餐管理'
        }
    },
    parent: 'activity'
};

const activityFoodType = {
    id: 'activityFoodType',
    router: {
        path: 'food-type',
        name: 'ActivityFoodType',
        component: () => import(/* webpackChunkName: "food-type" */ '../../views/activity/food/FoodType.vue'),
        meta: {
            title: '餐品管理'
        }
    },
    parent: 'activity'
};

const activityFoodTime = {
    id: 'activityFoodTime',
    router: {
        path: 'food-time',
        name: 'ActivityFoodTime',
        component: () => import(/* webpackChunkName: "food-time" */ '../../views/activity/food/FoodTime.vue'),
        meta: {
            title: '订餐时间管理'
        }
    },
    parent: 'activity'
};

const activityFoodSet = {
    id: 'activityFoodSet',
    router: {
        path: 'food-set',
        name: 'ActivityFoodSet',
        component: () => import(/* webpackChunkName: "food-set" */ '../../views/activity/food/FoodSet.vue'),
        meta: {
            title: '订餐设置'
        }
    },
    parent: 'activity'
};

const activityStayAssign = {
    id: 'activityStayAssign',
    router: {
        path: 'stay-assign',
        name: 'ActivityStayAssign',
        component: () => import(/* webpackChunkName: "stay-assign" */ '../../views/activity/stay/Assign.vue'),
        meta: {
            title: '住宿分配'
        }
    },
    parent: 'activity'
};

const activityStayInfo = {
    id: 'activityStayInfo',
    router: {
        path: 'stay-info',
        name: 'ActivityStayInfo',
        component: () => import(/* webpackChunkName: "stay-info" */ '../../views/activity/stay/AssignInfo.vue'),
        meta: {
            title: '住宿信息'
        }
    },
    parent: 'activity'
};

const activityHotel = {
    id: 'activityHotel',
    router: {
        path: 'hotel',
        name: 'ActivityHotel',
        component: () => import(/* webpackChunkName: "adh" */ '../../views/activity/stay/Hotel.vue'),
        meta: {
            title: '酒店管理'
        }
    },
    parent: 'activity'
};

const activityRoom = {
    id: 'activityRoom',
    router: {
        path: 'room',
        name: 'ActivityRoom',
        component: () => import(/* webpackChunkName: "adh" */ '../../views/activity/stay/Room.vue'),
        meta: {
            title: '房间管理'
        }
    },
    parent: 'activity'
};

const activityGiftAssign = {
    id: 'activityGiftAssign',
    router: {
        path: 'gift-assign',
        name: 'ActivityGiftAssign',
        component: () => import(/* webpackChunkName: "gift-assign" */ '../../views/activity/gift/Assign.vue'),
        meta: {
            title: '礼品分配'
        }
    },
    parent: 'activity'
};

const activityGift = {
    id: 'activityGift',
    router: {
        path: 'gift',
        name: 'ActivityGift',
        component: () => import(/* webpackChunkName: "gift" */ '../../views/activity/gift/Type.vue'),
        meta: {
            title: '礼品规格'
        }
    },
    parent: 'activity'
};

const activityVehicleAssign = {
    id: 'activityVehicleAssign',
    router: {
        path: 'vehicle-assign',
        name: 'ActivityVehicleAssign',
        component: () => import(/* webpackChunkName: "vehicle-assign" */ '../../views/activity/traffic/Assign.vue'),
        meta: {
            title: '车辆分配'
        }
    },
    parent: 'activity'
}

const activityTravelInfo = {
    id: 'activityTravelInfo',
    router: {
        path: 'travel-info',
        name: 'ActivityTravelInfo',
        component: () => import(/* webpackChunkName: "travel-info" */ '../../views/activity/traffic/TravelInfo.vue'),
        meta: {
            title: '行程信息'
        }
    },
    parent: 'activity'
}

const activityJourney = {
    id: 'activityJourney',
    router: {
        path: 'journey/:journey',
        name: 'ActivityJourney',
        component: () => import(/* webpackChunkName: "journey" */ '../../views/activity/traffic/Journey.vue'),
        meta: {
            title: '车辆行程'
        }
    },
    parent: 'activity'
}

const activityDriver = {
    id: 'activityDriver',
    router: {
        path: 'driver',
        name: 'ActivityDriver',
        component: () => import(/* webpackChunkName: "adr" */ '../../views/activity/traffic/Driver.vue'),
        meta: {
            title: '司机管理'
        }
    },
    parent: 'activity'
}

const activityVehicle = {
    id: 'activityVehicle',
    router: {
        path: 'vehicle',
        name: 'ActivityVehicle',
        component: () => import(/* webpackChunkName: "ave" */ '../../views/activity/traffic/Vehicle.vue'),
        meta: {
            title: '车辆管理'
        }
    },
    parent: 'activity'
}

const activityPass = {
    id: 'activityPass',
    router: {
        path: 'pass',
        name: 'ActivityPass',
        component: () => import(/* webpackChunkName: "adr" */ '../../views/activity/traffic/Pass.vue'),
        meta: {
            title: '通行证管理'
        }
    },
    parent: 'activity'
}

const activityDeliveryList = {
    id: 'activityDeliveryList',
    router: {
        path: 'delivery-list',
        name: 'ActivityDeliveryList',
        component: () => import(/* webpackChunkName: "delivery-list" */ '../../views/activity/delivery/DeliveryList.vue'),
        meta: {
            title: '预约列表'
        }
    },
    parent: 'activity'
};

const activityDeliveryCar = {
    id: 'activityDeliveryCar',
    router: {
        path: 'delivery-car',
        name: 'ActivityDeliveryCar',
        component: () => import(/* webpackChunkName: "delivery-car" */ '../../views/activity/delivery/DeliveryCar.vue'),
        meta: {
            title: '车型管理'
        }
    },
    parent: 'activity'
};

const activityDeliveryDetail = {
    id: 'activityDeliveryDetail',
    router: {
        path: 'delivery/detail/:carId',
        name: 'ActivityDeliveryDetail',
        component: () => import(/* webpackChunkName: "delivery-detail" */ '../../views/activity/delivery/DeliveryDetail.vue'),
        meta: {
            title: '送机服务详情'
        }
    },
    parent: 'activity'
};

const activityDeliverySet = {
    id: 'activityDeliverySet',
    router: {
        path: 'delivery-set',
        name: 'ActivityDeliverySet',
        component: () => import(/* webpackChunkName: "meal" */ '../../views/activity/delivery/DeliverySet.vue'),
        meta: {
            title: '送机服务设置'
        }
    },
    parent: 'activity'
};

const activityReceptionist = {
    id: 'activityReceptionist',
    router: {
        path: 'receptionist',
        name: 'ActivityReceptionist',
        component: () => import(/* webpackChunkName: "arc" */ '../../views/activity/Receptionist.vue'),
        meta: {
            title: '接待人员管理'
        }
    },
    parent: 'activity'
}


const activityMeetingRoom = {
    id: 'activityMeetingRoom',
    router: {
        path: 'meeting-room',
        name: 'ActivityMeetingRoom',
        component: () => import(/* webpackChunkName: "arc" */ '../../views/activity/MeetingRoom.vue'),
        meta: {
            title: '会议室信息'
        }
    },
    parent: 'activity'
}

const scene = {
    id: 'scene',
    router: {
        path: '/scene',
        name: 'Scene',
        component: () => import(/* webpackChunkName: "scene" */ '../../views/Scene'),
        meta: {
            title: '场景管理'
        }
    }
};

const guest = {id: 'guest', entity: 'guest'};

const insider = {
    id: 'insider',
    router: {
        path: '/insider',
        name: '内部人员管理',
        component: () => import(/* webpackChunkName: "insider" */ '../../views/Insider'),
        meta: {
            title: '内部人员管理'
        }
    }
};

const admin = {
    id: 'admin',
    router: {
        path: '/admin',
        name: '权限管理',
        component: () => import(/* webpackChunkName: "admin" */ '../../views/Admin'),
        meta: {
            title: '权限管理'
        }
    }
};

const template = {
    id: 'template',
    router: {
        path: '/template',
        name: 'Template',
        component: () => import(/* webpackChunkName: "temp" */ '../../views/Template'),
        meta: {
            title: '模板管理'
        }
    },
}

const templateDecorate = {
    id: 'templateDecorate',
    router: {
        path: '/decorate/temp/:id',
        name: 'TemplateDecorate',
        component: () => import(/* webpackChunkName: "tde" */ '../../views/Decorate'),
        meta: {
            title: '模板设置'
        }
    },
}

const icon = {
    id: 'icon',
    router: {
        path: '/icon',
        name: 'Icon',
        component: () => import(/* webpackChunkName: "icon" */ '../../views/Icon'),
        meta: {
            title: '图标管理'
        }
    },
}

// 2025杭州推介会嘉宾列表
const inviteGuest = {id: 'inviteGuest', entity: 'inviteGuest'};
const zdMeeting = {
    id: 'zdMeeting',
    router: {
        path: '/extra/zddsfh',
        name: 'ZdMeeting',
        component: () => import(/* webpackChunkName: "arc" */ '../../views/extra/ZdMeeting.vue'),
        meta: {
            title: '中东电商峰会'
        }
    },
}

export default {
    activityList,
    createActivity,
    activity,
    activityInfo,
    activityDetail,
    activityGroup,
    activityDecorate,
    activityStaff,
    activityHomePreview,
    activitySchedule,
    activityArticle,
    activityVideo,
    activityGuest,
    activityGuestVerify,
    activityGuestInfo,
    activityLocation,
    activityEnroll,
    activityMealAssign,
    activityMealInfo,
    activityMeal,
    activityFoodOrder,
    activityFoodType,
    activityFoodTime,
    activityFoodSet,
    activityStayAssign,
    activityStayInfo,
    activityHotel,
    activityRoom,
    activityGiftAssign,
    activityGift,
    activityVehicleAssign,
    activityTravelInfo,
    activityJourney,
    activityDriver,
    activityVehicle,
    activityPass,
    activityDeliveryList,
    activityDeliveryCar,
    activityDeliveryDetail,
    activityDeliverySet,
    activityReceptionist,
    activityMeetingRoom,
    scene,
    guest,
    insider,
    admin,
    icon,
    template,
    templateDecorate,
    inviteGuest,
    zdMeeting,
}
